import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { PlayerBonusResponse } from '@modules/players-bonuses/submodules/edit/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  PLAYER_BONUS_API_URL,
  PLAYER_BONUS_EDIT_PERMISSIONS,
  PLAYER_BONUS_QUERY_KEY,
} from '@modules/players-bonuses/submodules/edit/constants';

export default function usePlayerBonusQuery(id: Ref<string>): IContextQueryResult<PlayerBonusResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [PLAYER_BONUS_QUERY_KEY, id],
    queryFn: ({ signal }) => fetchGet<PlayerBonusResponse>(PLAYER_BONUS_API_URL(id.value), {
      signal,
      permission: PLAYER_BONUS_EDIT_PERMISSIONS.PLAYER_BONUS_EDIT,
    }),
  });
}
